import i18next from "i18next";

import global_es from "./es/global.json"
import global_en from "./en/global.json"
import { uselanguage } from "../hooks";


const lang = uselanguage();

i18next.init({
    fallbackLng: 'en',
    interpolation: { escapeValue: false }, //Allow use html tags 
    lng: lang || 'en',
    resources: {
        en: { global: global_en },
        es: { global: global_es },
    },
    supportedLngs: [ 'es', 'en' ],
})